export const DAY_NAMES =['M', 'T', 'W', 'T', 'F', 'S', 'S']